import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SearchIcon from '@material-ui/icons/Search';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InputBase from '@material-ui/core/InputBase';
import { withStyles } from '@material-ui/core/styles';

const custStyles = theme => ({
  root: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing.unit * 2,
    marginLeft: 0,
    width: '100%',
    border: '1px solid #bdbdbd',
  },
  searchIcon: {
    width: 36,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.5,
  },
  clearIcon: {
    width: 36,
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    top: 0,
    opacity: 0.5,
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
    lineHeight: '1.125rem',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: 36,
    paddingBottom: theme.spacing.unit,
    paddingLeft: 36,
    fontSize: '0.875rem',
    backgroundColor: '#fff'
  },
});

/**
 *  weui search component
 *
 */
class SearchBar extends Component {
  static propTypes = {
    /**
     * default value for the searchbar if any
     *
     */
    defaultValue: PropTypes.string,
    /**
     * default place holder text
     *
     */
    placeholder: PropTypes.string,
    /**
     * name of the input component
     *
     */
    searchName: PropTypes.string,
    /**
     * trigger when text change on input pass `text` property
     *
     */
    onChange: PropTypes.func,
    /**
     * trigger when user click clear icon
     *
     */
    onClear: PropTypes.func,
    /**
     * trigger when user click cancel button
     *
     */
    onCancel: PropTypes.func,
    /**
     * trigger when user submit (enter action)
     *
     */
    onSubmit: PropTypes.func,
    /**
     * language object consists of `cancel` property
     *
     */
    lang: PropTypes.object,
  };

  static defaultProps = {
    placeholder: '搜索',
    searchName: 'q',
    focus: false,
    onChange: undefined,
    onClear: undefined,
    onCancel: undefined,
    onSubmit: undefined,
    lang: { cancel: '取消' },
    autocomplete: 'off',
    styles: {}, //
  };

  constructor(props) {
    super(props);
    this.elInput = {};
    this.state = {
      focus: this.props.focus,
      clearing: false,
      text: this.props.defaultValue ? this.props.defaultValue : '',
    };

    if (this.props.defaultValue !== '') {
      if (this.props.onChange) {
        this.props.onChange(this.state.text);
      }
    }
  }

  componentDidMount() {
    if (this.state.focus) {
      this.elInput.focus();
    }
  }

  fnRef(el) {
    this.elInput = el;
  }

  changeHandle(e) {
    let text = e.target.value;
    if (this.props.onChange) {
      this.props.onChange(text, e);
    }
    if (text === '') {
      this.clearHandle(e);
      return;
    }
    this.setState({ text });
  }

  cancelHandle(e) {
    this.setState({
      focus: false,
      text: '',
    });
    if (this.props.onCancel) {
      this.props.onCancel(e);
    }
    if (this.props.onChange) {
      this.props.onChange('', e);
    }
  }

  clearHandle(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ text: '', clearing: true });
    if (this.props.onClear) {
      this.props.onClear('', e);
    }
    if (this.props.onChange) {
      this.props.onChange('', e);
    }
    this.elInput.focus();
  }

  blurHandle(e) {
    if (this.state.text === '') {
      this.setState({ focus: false });
    }
  }

  submitHandle(e) {
    if (this.props.onSubmit) {
      e.preventDefault();
      e.stopPropagation();
      this.elInput.blur();
      this.props.onSubmit(this.state.text, e);
    }
  }

  render() {
    const { classes, placeholder, styles } = this.props;

    return (
      <form onSubmit={this.submitHandle.bind(this)} action="">
        <div className={classes.root} style={styles.root}>
          <div className={classes.searchIcon} style={styles.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder={placeholder}
            id={this.id}
            inputRef={this.fnRef.bind(this)}
            value={this.state.text}
            onChange={this.changeHandle.bind(this)}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
          />
          {this.state.text !== '' && (
            <div
              className={classes.clearIcon}
              style={styles.clearIcon}
              onClick={this.clearHandle.bind(this)}
            >
              <HighlightOffIcon />
            </div>
          )}
        </div>
      </form>

      // <div className={clz}>
      //     <form className='weui-search-bar__form' onSubmit={this.submitHandle.bind(this)}>
      //         <div className='weui-search-bar__box'>
      //             <Icon value='search'/>
      //             <input
      //                 ref='searchInput'
      //                 type='search'
      //                 name={searchName}
      //                 className='weui-search-bar__input'
      //                 placeholder={placeholder}
      //                 onFocus={e=>this.setState({focus: true})}
      //                 onBlur={this.blurHandle.bind(this)}
      //                 onChange={this.changeHandle.bind(this)}
      //                 value={this.state.text}
      //                 autoComplete={autocomplete}
      //             />
      //             {/*React will not trigger onMouseDown when not onClick presented*/}
      //             <a
      //                 className='weui-icon-clear'
      //                 onClick={this.clearHandle.bind(this)}
      //             />
      //         </div>
      //         <label
      //             className='weui-search-bar__label'
      //             onClick={()=>{
      //                 let searchInput = this.refs.searchInput;
      //                 if (searchInput) {
      //                     searchInput.focus();
      //                 }
      //             }}
      //             style={{display: this.state.text ? 'none' : null}}
      //         >
      //             <Icon value='search'/>
      //             <span>{placeholder}</span>
      //         </label>
      //     </form>
      //     <a className='weui-search-bar__cancel-btn' onClick={this.cancelHandle.bind(this)}>{this.props.lang.cancel}</a>
      // </div>
    );
  }
}

export default withStyles(custStyles)(SearchBar);
